<template>
<div>
    <b-row>
        <b-col style="margin-top:-15px; margin-bottom: 5px;">
            <!-- status:{{nippou.status}} -->
            <span v-show="nippou.status<6&&!loading" :class="'badge badge-'+nippou.status_class">{{nippou.status_name}}</span>&nbsp;
            <span v-show="loading" class=""><small><b-spinner small /></small> Loading...</span>&nbsp;
        </b-col>
    </b-row>
    <b-row v-if="!(display_mode=='approve'&&nippou.status<2)||(auth_user.id == nippou.user.id)">
        <b-col md="12" lg="9">
            <b-row class="mr-md-n4">
                <b-col>
                    <b-row>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="">所属グループ</label>
                                <b-form-input type="text" class="bg-white text-dark" disabled v-model="nippou.user.group.name"></b-form-input>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="">氏名</label>
                                <b-form-input type="text" class="bg-white text-dark" disabled v-model="nippou.user.name"></b-form-input>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="">日付</label>
                                <b-form-input type="text" class="bg-white text-dark text-center" disabled :value="moment(nippou.day,'YYYY-MM-DD').format('YYYY年MM月DD日')"></b-form-input>
                            </div>
                        </div>
                    </b-row>

                    <b-row>
                        <div class="col-md-9 col-lg-9">
                            <div class="card mb-3">
                                <table class="table table-bordered table-sm mb-0">
                                    <thead>
                                        <tr class="text-center small">
                                            <th>
                                                業務種類
                                            </th>
                                            <th>
                                                作業内容
                                            </th>
                                            <th width="100">
                                                作業時間
                                            </th>
                                            <!-- <th>
                                                コメント
                                            </th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr is="nippou-item-component"
                                            v-for="nippouItem in nippouItems"
                                            @change="updateNippouItem"
                                            @delete="deleteNippouItem"
                                            :key="nippouItem.id" 
                                            :nippou-item="nippouItem"
                                            :disabled="nippou.status>1"></tr>

                                        <tr v-if="nippouItems.length<1">
                                            <td></td>
                                            <td colspan="3" class="p-3">記録がありません。</td>
                                        </tr>
                                        <tr>
                                            <td scope="row" width="150" style="vertical-align: middle">
                                                <activity-selector v-on:workcontent-selected="addNippouItem" v-if="nippou.status<=1"></activity-selector>
                                            </td>
                                            <td class="text-right">合計時間：</td>
                                            <td class="text-right">
                                                <span v-bind:class="['text-right',(total_hours!=total_worked_hours)?'text-danger':'']">
                                                    {{total_worked_hours | decimal(2)}}<br>
                                                </span>
                                                <small class="text-muted">{{total_hours | decimal}}</small>
                                            </td>
                                            <!-- <td></td> -->
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3">
                            <b-card class="ml-md-n4 mb-3" header="コメント" body-class="p-2" header-class="small py-1">
                                <nippou-chat :nippou_id="this.nippou.id"></nippou-chat>
                            </b-card>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
        <b-col lg="3">
            <div class="row">
                <div class="col-12">
                    <div class="card mb-3">
                        <div class="card-header p-1 text-center">
                            作業シフト<br>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <select class="form-control form-control-sm" v-model="selected_shift_id" @change="updateShift()" v-if="nippou.status<=1">
                                        <option value="">----- 選択 -----</option>
                                        <optgroup v-for="option in shift_list" :key="option.id" :label="option.description">
                                            <option v-for="shift in option.shifts" :key="shift.id" v-bind:value="shift.id">
                                                {{ option.description }}：{{ shift.description }}
                                            </option>
                                        </optgroup>
                                    </select>
                                    <input type="text" readonly class="form-control-plaintext form-control-sm text-muted" 
                                        :value="nippou.shift.shift_group.description+'：'+nippou.shift.description"
                                        v-if="nippou.status>1">
                                </div>
                                <div class="col-12">
                                    <div class="input-group input-group-sm mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">開始時間</span>
                                        </div>
                                        <b-form-input @change="updateNippouHours()" v-model="nippou.start_hour" :disabled="!is_editable" class="text-right bg-white" type="text"></b-form-input>
                                    </div>
                                    <div class="input-group input-group-sm mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">終了時間</span>
                                        </div>
                                        <b-form-input @change="updateNippouHours()" v-model="nippou.end_hour" :disabled="!is_editable" class="text-right bg-white" type="text"></b-form-input>
                                    </div>
                                    <div class="input-group input-group-sm  mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">休憩時間</span>
                                        </div>
                                        <b-form-input @change="updateNippouHours()" v-model="nippou.breaktime" :disabled="!is_editable" class="text-right bg-white" type="text" step="0.01" min="0"></b-form-input>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div v-if="nippou.shift.description == '平日特別'" class=" w-100">
                                        <div class="input-group input-group-sm mb-1" > 
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">コメント</span>
                                            </div>

                                            <b-form-textarea v-model="comment" :disabled="nippou.status>1" class="form-control text-left bg-white" type="text"></b-form-textarea>
                                            
                                        </div>
                                        <div class="w-100">
                                            <input @click="saveComment()" :disabled="comment_saving" v-if="!(nippou.status>1)" type="submit" class="btn btn-success btn-sm float-right" value="コメント保存">
                                            <span v-show="comment_saving" class="float-right mr-2"><small><b-spinner small /></small></span>&nbsp;
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-show=" !is_regular_service && !zangyou_was_applied && nippou.status <= 1">
                        <div class="card-header p-1 text-center">
                            時間外勤務<br>
                        </div>

                        <b-alert style="font-size:0.95rem" class="p-1 m-1" v-for="(error, key) in validation_errors" :key="key" show variant="danger">{{ error[0] }}</b-alert>
                        <div class="card-body">
                            <button class="btn btn-sm btn-primary mb-3" @click="show_zangyou_application_div = !show_zangyou_application_div" v-if="!show_zangyou_application_div && !is_regular_service && !zangyou_was_applied && nippou.status <= 1">時間外申請</button>
                            <b-card
                                v-if="show_zangyou_application_div"
                                border-variant="success"
                                header="時間外申請"
                                header-bg-variant="success"
                                header-text-variant="white"
                                align="center"
                            >
                                <b-card-text>
                                    <div class="col-md-8 col-lg-6 mx-0 px-0">
                                        <div class="input-group input-group-sm mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">開始時間</span>
                                            </div>
                                            <b-form-input  v-model="zangyou_application.start"  class="text-right bg-white" type="text"></b-form-input>
                                        </div>
                                        <div class="input-group input-group-sm mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">終了時間</span>
                                            </div>
                                            <b-form-input v-model="zangyou_application.end" class="text-right bg-white" type="text"></b-form-input>
                                        </div>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend text-center">
                                                <div class="input-group-text" style="width:73px;">時間</div>
                                            </div>
                                            <b-form-input autocomplete="off" v-model="zangyou_application.time" class="text-right bg-white" type="text"></b-form-input>
                                        </div>
                                        <small class="text-muted">例：1.5</small>
                                    </div>
                                    <div class="input-group input-group-sm mb-1 mt-3" > 
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">業務内容</span>
                                        </div>
                                        <b-form-textarea v-model="zangyou_application.work_contents" :disabled="nippou.status>1" class=" form-control text-left bg-white" type="text" step="0.01" min="0"></b-form-textarea>
                                    </div>
                                    <div class="w-100 mt-3">
                                        <div class="float-left">
                                            <input  @click="show_zangyou_application_div = !show_zangyou_application_div" type="button" class="btn btn-danger btn-sm " value="キャンセル">
                                        </div>
                                        <div class="float-right">
                                            <span v-show="comment_saving" class=" mr-2"><small><b-spinner small /></small></span>
                                            <input @click="zangyouApply()" :disabled="comment_saving" v-if="!(nippou.status>1)" type="submit" class="btn btn-success btn-sm px-3 " value="保存">
                                        </div>
                                    </div>
                                </b-card-text>
                            </b-card>
                        </div>
                         
                    </div>
                </div>
            </div>

            <zangyou-component 
                :zangyou_was_applied="zangyou_was_applied" 
                @zangyouUpdated="zangyouUpdated" 
                :user-name="nippou.user.username" 
                :day="nippou.day"
                :approver_id="nippou.user.group.admin_id"
            ></zangyou-component>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            添付資料
                        </div>
                        <div class="card-body">
                            <p class="card-text"
                                v-for="attach in attachments"
                                :key="attach.id">

                                <b-link href="#"
                                        v-b-modal="'file'+attach.id" 
                                        :class="{'disabled text-muted':file.deletingId==attach.id}"
                                        v-if="file.deletedId!=attach.id">
                                    <i class="fas fa-file"></i> {{attach.file_name}} <i class="fas fa-eye"></i>
                                </b-link>

                                <b-link href="#" @click="deleteAttachment(attach)" :class="{'d-none':nippou.status>1}" class="text-danger">
                                    <i v-if="file.deletingId == attach.id" class="fas fa-spinner fa-spin"></i>
                                    <i v-if="file.deletingId != attach.id&&file.deletedId!=attach.id" class="fas fa-times-circle"></i>
                                </b-link>

                                <b-modal size="lg" v-bind:id="'file'+attach.id" title="添付ファイル" hide-footer >
                                    
                                    <div class="text-center">
                                        <strong> ファイル名:</strong>   {{ attach.file_name }} <br>
                                    </div>

                                    <!-- Image -->
                                    <b-img class="mb-2" v-if="attach.mime_type.startsWith('image')" :src="attach.url" fluid />

                                    <!-- PDF -->
                                    <div v-if="attach.mime_type.endsWith('pdf')" class="text-center">
                                        <iframe :src="attach.url" type="application/pdf" width="100%" height="400px"></iframe>
                                        <br>
                                    </div>

                                    <!-- File -->
                                    <div v-if="!attach.mime_type.startsWith('image') && !attach.mime_type.endsWith('pdf')" class="text-center">
                                        <i class="fas fa-file fa-5x mb-5"></i><br>
                                    </div>

                                    <span class="float-left">
                                        <strong> サイズ:</strong>  ({{ formatBytes( attach.size)}}) 
                                    </span>
                                    <b-link :href="attach.url" class="btn btn-success mb-2 float-right" download>
                                        ダウンロード
                                    </b-link>

                                </b-modal>
                            </p>
                            <p class="card-text">
                                <file-upload 
                                    :url="url+'upload'"
                                    @change="getAttachments()"
                                    v-if="nippou.status<=1">
                                </file-upload>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </b-col>
    </b-row>
    <hr>
    <b-row >
        <b-col class="text-center">
            <b-button v-if="auth_user.id==nippou.user.id||display_mode=='input'" @click="confirmSave()" v-show="buttons.button1.visible" :disabled="buttons.button1.disabled||loading" :variant="buttons.button1.variant" class="float-right px-5" >
                {{buttons.button1.text}}
            </b-button>
            <b-button @click="changeNippouStatus(buttons.buttonAdmin.action)" v-show="buttons.buttonAdmin.visible" :disabled="buttons.buttonAdmin.disabled||loading" :variant="buttons.buttonAdmin.variant" class="px-5 float-left" >
                {{buttons.buttonAdmin.text}}
            </b-button>
            <b-button @click="changeNippouStatus(buttons.buttonPresident.action)" v-show="buttons.buttonPresident.visible" :disabled="buttons.buttonPresident.disabled||loading" :variant="buttons.buttonPresident.variant" class="px-5 float-left ml-2" >
                {{buttons.buttonPresident.text}}
            </b-button>
            <b-button
                :disabled="nippou.urlToNextShachouApproval==null"
                :href="nippou.urlToNextShachouApproval"
                variant="primary"
                v-if="$can('社長承認')"
                class="px-5 float-left ml-4"
            >
                未承認へ移動
            </b-button>
        </b-col>
    </b-row>
</div>
</template>

<script>
    import moment from 'moment'
    export default {
        data: function() {
            return {
                moment: moment,
                auth_user: {id:-1},
                zangyou: {time:0,schedule_start:'',schedule_end:''},
                nippou: {
                    status: 0,
                    status_class: 'secondary',
                    status_name: '...',
                    start_hour: 0,
                    end_hour: 0,
                    breaktime: 0,
                    day: '',
                    media: [],
                    shift: {
                        description: '',
                        shift_group:{
                            description: '',
                        }
                    },
                    user: {
                        name: null,
                        group: {
                            description: null
                        }
                    }
                },
                nippouItems: [],
                attachments: [],
                total_hours: 0.00,
                total_worked_hours: 0.00,
                file: {
                    deletingId : null,
                    deletedId : null,

                },
                loading: true,
                comment_saving: false,
                comment: '',
                display_mode: "edit",
                buttons: {
                    button1: {
                        variant: 'primary',
                        disabled: true,
                        text: 'Button',
                        visible: false,
                        action: null,
                    },
                    buttonAdmin: {
                        variant: 'primary',
                        disabled: true,
                        text: 'Button',
                        visible: false,
                        action: null,
                    },
                    buttonPresident: {
                        variant: 'primary',
                        disabled: true,
                        text: 'Button',
                        visible: false,
                        action: null,
                    },
                },
                selected_shift_id: null,
                shift_list: [
                    {
                        group:"通常勤務", 
                        shifts:[
                            {"id": 1,"description": "平日","start": "08:30:00","end": "17:30:00"}
                        ]
                    },
                    {
                        group:"オペレーター", 
                        shifts:[
                            {"id": 2,"description": "Ⅰ勤","start": "05:45:00","end": "14:45:00"},
                            {"id": 3,"description": "Ⅱ勤","start": "13:45:00","end": "22:45:00"},
                            {"id": 4,"description": "Ⅲ勤","start": "21:45:00","end": "06:45:00"}
                        ]
                    },
                    {group:"ラボ・平日", shifts:[
                        {"id": 5,"description": "Ⅰ勤","start": "07:00:00","end": "16:00:00"},
                        {"id": 6,"description": "Ⅱ勤","start": "13:00:00","end": "22:00:00"},
                        {"id": 7,"description": "Ⅲ勤","start": "21:00:00","end": "06:00:00"}
                    ]},
                    {group:"ラボ・休日", shifts:[
                        {"id": 8,"description": "Ⅰ勤","start": "06:45:00","end": "15:45:00"},
                        {"id": 9,"description": "Ⅲ勤","start": "21:45:00","end": "06:45:00"},
                        {"id": 10,"description": "Ⅱ勤","start": "13:45:00","end": "22:45:00"}
                    ]}
                ],
                show_zangyou_application_div: false,
                zangyou_application: {
                    start: '',
                    end: '',
                    time: '',
                    work_contents: ''
                },
                zangyou_was_applied: false,
                validation_errors: ''
            }
        },
        props: {
            url: String,
            value: Object,
            mode: String
        },
        computed:{
            has_zangyou_application: function(){
                return this.zangyou.time > 0
            },
            is_regular_service: function() {
                return this.nippou.shift.description == '平日'　|| this.nippou.shift.description == '平日特別' || this.nippou.shift.description == '' || this.nippou.shift.description == '休日出勤' 
            },
            is_editable: function(){
                return this.nippou.status <= 1 && (this.nippou.shift.description == '平日特別' || this.nippou.shift.description == '休日出勤')
            },
            hours_is_empty: function(){
                return this.nippou.start_hour == "00:00" || this.nippou.end_hour == '00:00' || this.nippou.start_hour == '' || this.nippou.end_hour == '' || this.nippou.start_hour == 0 || this.nippou.end_hour == 0 || this.nippou.start_hour == null || this.nippou.end_hour == null  
                
              
            }
        },
        watch:{
            value: function(val) {
                this.nippou = this.value
            },
            nippou:{
                handler(val){
                    if (this.nippou.shift.end) {
                        this.zangyou_application.start = moment(this.nippou.shift.end,'HH:mm:ss').format('HH:mm')
                    }
                },
                deep: true
            },
            'nippou.shift.description': function(){
            }
        },
        beforeCreate(){
        },
        methods: {
            confirmSave(){
                if((this.total_worked_hours == this.total_hours) || this.buttons.button1.action == 'edit'){
                    this.changeNippouStatus(this.buttons.button1.action)
                }else{
                    if(this.is_regular_service || this.has_zangyou_application){
                        alert('予定作業時間と実働作業時間が合わない。')
                    }else{
                        if(this.total_worked_hours > this.total_hours){
                            alert('実働作業時間が予定作業時間を超えているため時間外勤務申請を行ってください。')
                        }else if(this.total_worked_hours < this.total_hours){
                            alert('予定作業時間と実働作業時間が合わない。')
                        }
                    }
                }
            },
            formatBytes: function (a,b) {
                if(0==a)return "0 Bytes ";
                var c=1024,d=b||2,e=[ "Bytes ", "KB ", "MB ", "GB ", "TB ", "PB ", "EB ", "ZB ", "YB "],
                f=Math.floor(Math.log(a)/Math.log(c));
                return parseFloat((a/Math.pow(c,f)).toFixed(d))+" "+e[f]
            },
            refresh: function () {
            },
            addNippouItem(nippouItem) {
                window.axios.post(this.getUrl()+'item', {work_content:nippouItem} )
                .then(( response ) => {
                }).catch((error) => {
                }).then(()=>{
                    this.getNippouItems()
                });
            },
            zangyouApply() {
                window.axios.post('/api/zangyouuApply', {
                    time:this.zangyou_application.time,
                    start: this.zangyou_application.start == '' ? '' : this.nippou.day+ ' ' + this.zangyou_application.start,
                    end: this.zangyou_application.end == '' ? '' : this.nippou.day+ ' ' + this.zangyou_application.end,
                    work_contents:this.zangyou_application.work_contents,
                    user_id:this.nippou.user.id, day: this.nippou.day} )
                .then(( response ) => {
                    this.zangyou_was_applied = true
                    this.zangyou = response.data.zangyou
                }).catch((error) => {
                    if(error.response.status == 422){
                        this.validation_errors = error.response.data.errors
                    }
                })
            },
            deleteNippouItem(nippouItem) {
                window.axios.delete(this.getUrl()+'item/'+ nippouItem.id )
                .then(( response ) => {
                }).catch((error) => {
                }).then(()=>{
                    this.getNippouItems()
                });
            },
            updateNippouItem(nippouItem) {
                this.calculateHours();
                window.axios.put(
                    this.getUrl()+'item/'+nippouItem.id, 
                    {work_content:nippouItem} 
                ).then(( response ) => {
                }).catch((response) => {
                }).then(()=>{
                    this.getNippouItems()
                });
            },
            getShiftList() {
                window.axios.get('/api/shift') .then(( {data} ) => {
                    this.shift_list = data.shift_list
                })
            },
            updateShift() {
                this.shift_list.forEach(item => {
                    item.shifts.forEach(shift => {
                        if(shift.id == this.selected_shift_id) {
                            shift.shift_group = {description:item.description}
                            this.nippou.shift_id = shift.id
                            this.nippou.shift = shift
                            this.nippou.start_hour = shift.start == null ? null : moment(shift.start,'HH:mm').format('HH:mm')
                            this.nippou.end_hour = shift.end == null ? null :  moment(shift.end,'HH:mm:ss').format('HH:mm')
                        }
                    })
                })
                this.updateNippouHours();
            },
            updateNippouHours() {
                this.calculateHours();
                window.axios.put(
                    this.getUrl(), this.nippou 
                ).then(( response ) => {
                    this.getNippou()
                }).catch((error) => {
                    this.getNippou()
                })
            },
            calculateHours() {
                this.calculateTotalHours()
                var total = 0
                this.nippouItems.forEach(item => {
                    total += parseFloat(item.time)
                });
                this.total_worked_hours = (total.toFixed(2))
            },
            calculateTotalHours() {
                var total = 0
                var day_start = '2019-03-13 '
                var day_end = '2019-03-13 '
                if(this.nippou.end_hour != null && this.nippou.start_hour != null){
                    this.nippou.end_hour = moment(this.nippou.end_hour,'HH:mm').format('HH:mm')
                    this.nippou.start_hour = moment(this.nippou.start_hour,'HH,mm').format('HH:mm')
                    if(this.nippou.end_hour < this.nippou.start_hour)
                        day_end = '2019-03-14 '
                    total = moment
                            .duration(moment(day_end+this.nippou.end_hour,'YYYY-MM-DD HH:mm:ss')
                            .diff(moment(day_start+this.nippou.start_hour,'YYYY-MM-DD HH:mm:ss'))
                            ).asHours()
    
                    this.total_hours = (total.toFixed(2)) - (+this.nippou.breaktime) + parseFloat(this.zangyou.time) 
                }else {
                    this.total_hours = 0
                }
            },
            zangyouUpdated(zangyou){
                this.zangyou = zangyou
                this.calculateTotalHours()
                if(!zangyou.time == 0){
                    this.zangyou_was_applied = true
                }
            },
            getUrl() {
                return '/api/user/' + this.nippou.user.username + '/nippou/' + this.nippou.nid + '/'
            },
            getNippou() {
                this.getNippouItems()
                this.getAttachments()
                this.calculateTotalHours()
                this.updateButtons()
                this.selected_shift_id = this.nippou.shift_id;
                this.updateShiftList()
                
                this.loading = false
            },
            // sobrescreve o shift_list com as informações do nippou, pq ao ao selecionar outro shift ele eatava resetando o que já estava no banco de dados.
            updateShiftList(){
                this.shift_list.forEach( (item,key) => {
                    item.shifts.forEach((shift, chave) => {
                        if(shift.id == this.selected_shift_id) {
                            this.shift_list[key].shifts[chave].start = this.nippou.start_hour
                            this.shift_list[key].shifts[chave].end = this.nippou.end_hour
                        }
                    })
                })
            },
            getNippouItems() {
                window.axios.get(this.getUrl()+'item').then(({ data }) => {
                    this.nippouItems = data.nippouItems
                    this.calculateHours()
                }).catch((error) => {
                });
            },
            getAttachments() {
                window.axios.get(this.getUrl()+'attachments').then(({ data }) => {
                    this.attachments = data
                }).catch((error) => {
                });
            },
            deleteAttachment(attachment) {
                if (!confirm('添付資料を削除しますか？')) return
                this.file.deletingId = attachment.id
                
                window.axios.delete(
                    this.getUrl()+'attachment/'+attachment.id
                ).then(({ data }) => {
                    this.getAttachments()
                }).catch((error) => {
                }).then(()=>{
                    this.file.deletedId = attachment.id
                    this.file.deletingId = null
                })
            },
            updateButtons() {
                let edit = {
                    visible: true,
                    variant: 'warning',
                    disabled: false,
                    text: '編集',
                    action: 'edit'
                }
                
                switch (this.nippou.status) {
                    case 0:
                        this.buttons.button1 = {
                            visible: true,
                            variant: 'success',
                            disabled: false,
                            text: '登録',
                            action: 'register'
                        }
                        this.buttons.buttonAdmin.visible = false
                        this.buttons.buttonPresident.visible = false
                        
                        break;
                    case 1:
                        this.buttons.button1 = {
                            visible: true,
                            variant: 'success',
                            disabled: false,
                            text: '保存',
                            action: 'save'
                        }
                        this.buttons.buttonAdmin.visible = false
                        this.buttons.buttonPresident.visible = false
                        
                        break;
                    case 2:
                        this.buttons.button1 = edit

                        this.buttons.buttonAdmin = {
                            visible: true,
                            variant: 'primary',
                            disabled: (this.nippou.user.group.admin_id != this.auth_user.id),
                            text: '管理者 承認する',
                            action: 'admin_approval'
                        }
                        this.buttons.buttonPresident = {
                            visible: true,
                            variant: 'primary',
                            disabled: (!this.$can('社長承認')),
                            text: '社長 承認する',
                            action: 'shachou_approval'
                        }
                        break;
                    case 3:
                        this.buttons.buttonAdmin = {
                            visible: true,
                            variant: 'primary',
                            disabled: (this.nippou.user.group.admin_id != this.auth_user.id),
                            text: '管理者 承認する',
                            action: 'admin_approval'
                        }
                        this.buttons.buttonPresident = {
                            visible: true,
                            variant: 'success',
                            disabled: false,
                            text: '社長 承認済み',
                            action: null
                        }
                        break;
                    case 4:
                        this.buttons.button1 = edit
                        this.buttons.buttonAdmin = {
                            visible: true,
                            variant: 'success',
                            disabled: false,
                            text: '管理者 承認済み',
                            action: null
                        }
                        this.buttons.buttonPresident = {
                            visible: true,
                            variant: 'primary',
                            disabled: (!this.$can('社長承認')),
                            text: '社長 承認する',
                            action: 'shachou_approval'
                        }
                        break;
                    case 6:
                        this.buttons.button1 = edit
                        this.buttons.buttonAdmin = {
                            visible: true,
                            variant: 'success',
                            disabled: false,
                            text: '管理者 承認済み',
                            action: null
                        }
                        this.buttons.buttonPresident = {
                            visible: true,
                            variant: 'success',
                            disabled: false,
                            text: '社長 承認済み',
                            action: null
                        }

                    default:
                        break;
                }

            },
            changeNippouStatus(action) {
                if(action == 'save'){
                    if(this.hours_is_empty){
                        alert('開始時間または終了時間が必須。')
                        return false
                    }
                }
                if(action == null) return false
                if(action == 'edit') {
                    // rever tradução
                    // if(!confirm('編集されると再承認を必要になります。')) return false
                    // if(this.nippou.status == 2 || this.nippou.status == 3) action = 0
                }
                this.loading = true
                window.axios.put(
                    this.getUrl() + 'action/', {action:action}
                ).then((response)=>{
                    if(response.data.erro){
                        alert(response.data.erro)
                        location.reload()
                    }
                    this.nippou.admin_is_reapprove = response.data.admin_is_reapprove
                    this.nippou.shachou_is_reapprove = response.data.admin_is_reapprove
                    this.nippou.status = response.data.status
                    this.nippou.urlToNextShachouApproval = response.data.urlToNextShachouApproval
                    this.nippou.status_name = response.data.status_name
                    this.updateButtons()
                }).catch((error) => {
                }).finally(()=>{
                    this.loading = false
                })
            },
            saveComment(){
                this.comment_saving = true
                let comment = this.comment
                window.axios.put(
                    this.getUrl() + 'saveComment/', {comment}
                ).then((response)=>{
                    if(response.data.commentSave == 'empty'){
                        this.getComments('empty')
                    }
                    this.comment_saving = false
                })
            },
            getComments(empty = null) {
                window.axios.get(this.getUrl()+'getComment').then(({ data }) => {
                    if(empty){
                        alert('cannot be null')
                    }
                    this.comment = data
                }).catch((error) => {
                });
            },
        },
        created() {
            this.auth_user = window.authUser
            this.display_mode = this.mode
            this.getShiftList()
            this.nippou = this.value
            this.getNippou()
        }
    }
</script>
